import React, {Component, useState} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import FuncionariosTable from './FuncionariosTable'
import { Alert, AlertTitle, Collapse, Paper, Snackbar } from '@mui/material'
const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class FuncionariosPage extends Component {


    constructor(props) {
        super(props)

        this.state = {
            funcionarios: [],
            entidades: [],
            estados: [
              {id: "A", nombre: "Activo"},
              {id: "I", nombre: "Inactivo"},
              {id: "B", nombre: "Baja"}
            ],
            mostrarAlerta: false,
            mensajeAlerta: '',
            severidadAlerta: 'info',
        }


        this.cmbEntidades = React.createRef()
        this.cmbEstados = React.createRef()
        this.txtCodigo = React.createRef()


        this.btnBuscarClick = this.btnBuscarClick.bind(this)
    }

    showAlert = (mensaje, severidad) => {
      this.setState({
          mostrarAlerta: true,
          mensajeAlerta: mensaje,
          severidadAlerta: severidad,
      });
    }
  
    handleCloseAlert= (event, reason) => {
      if (reason === 'clickaway') {
        return; // Evitar que se cierre si el usuario hace clic fuera
      }
      this.setState({ mostrarAlerta: false })
    }

    btnBuscarClick() {
      this.queryFuncionarios()
    }

    queryEntidades() {
      console.log('Consultando entidades....')
      var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {},
	      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
          this.showAlert('Error consultando entidades', 'error')
	        //alert("Error consultando entidades")
	        //console.log('Error respuesta consultando entidades')
            this.setState({
				      entidades: [],
              mensajeError: data.message
            })
	      } else {
	        //console.log('Entidades consultadas')
            this.setState({
              entidades: data
              })
	      }
	    })
      
  
    }

    queryFuncionarios() {
        var filtroIdEstado = 0
        var filtroCodigo = ''

        if(this.cmbEstados.current.value !== 0){
          filtroIdEstado = this.cmbEstados.current.value
        }

        filtroCodigo = this.txtCodigo.current.value.toString()
        
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
            filtro_id_estado: filtroIdEstado,
            filtro_codigo: filtroCodigo
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/funcionarios/list'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
          this.showAlert('Error consultando funcionarios', 'error')
	        //alert("Error consultando funcionarios")
	        //console.log('Error respuesta funcionarios')
              this.setState({
                funcionarios: [],
                mensajeError: data.message
              })
	      } else {
	        //console.log('Funcionarios consultados')
	          this.setState({
	            funcionarios: data
	           })
	      }
	    })
    }

    componentDidMount() {
      this.queryFuncionarios()
      this.queryEntidades()
  }

    render() {
        return(
          <Box>
              <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
                Funcionarios
              </Typography>

              <Paper elevation={16}>
                <Card>
                  <CardContent>
                    <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                      <Grid container spacing={2}>
                        <Grid item>
                          <Typography gutterBottom variant="h6" component="div">
                            Buscar funcionarios:
                          </Typography>
                        </Grid>

                        <Grid item container spacing={2}>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <InputLabel>Estado</InputLabel>
                              <Select
                                label="Estado"
                                inputRef={this.cmbEstados}
                                defaultValue={0}>
                                <MenuItem value={0}>-- Todas los estados --</MenuItem>
                                {this.state.estados.map(estado => (
                                  <MenuItem key={estado.id} value={estado.id}>{estado.nombre}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl>
                              <TextField
                                label="Identificación"
                                id="outlined-basic"
                                variant="outlined"
                                inputRef={this.txtCodigo}
                                inputProps={{ inputMode: 'numeric', maxLength: 10, pattern: '[0-9]*' }}
                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10) }}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Button variant="contained" onClick={this.btnBuscarClick}>Buscar</Button>
                    <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                    </Snackbar>
                  </CardActions>
                </Card>
              </Paper>

              <Divider style={{"marginTop": 10, "marginBottom": 10}} />

              <Paper elevation={16} >
                <Card>
                    <CardContent>
                      <Typography gutterBottom variant="h6" component="div">
                        Listado funcionarios:
                      </Typography>
                        <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                        <FuncionariosTable funcionarios={this.state.funcionarios}  eventoSeleccionar={this.btnSeleccionarRegistro} />
                        </Box>
                    </CardContent>
                </Card>
              </Paper>
            

          </Box>
        )
    }

}

export default FuncionariosPage